import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { obtenerDescargaPorGrado, obtenerMercaderiaGrado3, obtenerDescargaFueraDeGrado } from '../../actions/listados'
import TotalDescargaPorGrado from './TotalDescargaPorGrado'
import LiquidacionMercaderiaGrado3 from './LiquidacionMercaderiaGrado3'
import LiquidacionFueraDeGrado from './LiquidacionFueraDeGrado'

function DescargaPorGrado (props) {
  const { obtenerDescargaPorGrado, obtenerMercaderiaGrado3, obtenerDescargaFueraDeGrado } = props

  useEffect(() => {
    obtenerDescargaPorGrado(new Date(), new Date())
    obtenerMercaderiaGrado3(new Date(), new Date())
    obtenerDescargaFueraDeGrado(new Date(), new Date())
  }, [obtenerDescargaPorGrado, obtenerMercaderiaGrado3, obtenerDescargaFueraDeGrado])

  const actualizarFechas = (fechaD, fechaH) => {
    obtenerDescargaPorGrado(fechaD, fechaH)
    obtenerMercaderiaGrado3(fechaD, fechaH)
    obtenerDescargaFueraDeGrado(fechaD, fechaH)
  }

  return (
    <>
      <div className='container-entre-fechas' style={{ margin: '-3% auto 0 auto' }}>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>

      <TotalDescargaPorGrado />
      <hr />

      <LiquidacionMercaderiaGrado3 />
      <hr />

      <LiquidacionFueraDeGrado />

    </>
  )
}

const mapActionsToProps = {
  obtenerDescargaPorGrado,
  obtenerMercaderiaGrado3,
  obtenerDescargaFueraDeGrado
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(DescargaPorGrado)
